import { render, staticRenderFns } from "./VerticalProgressBar.vue?vue&type=template&id=3771ecfa"
import script from "./VerticalProgressBar.vue?vue&type=script&lang=js"
export * from "./VerticalProgressBar.vue?vue&type=script&lang=js"
import style0 from "./VerticalProgressBar.vue?vue&type=style&index=0&id=3771ecfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-progress-bar/progress-types/VerticalProgressBar.vue
// module id = jrTD
// module chunks = 41